module.exports = __webpack_public_path__ + "dad2b0689016dad1cf92628212a89959.MP3";